<div id="loadingScreen" *ngIf="isLoading | async" class="overlay">
  <div class="ci-spinner-wrapper">
    <p-progressSpinner></p-progressSpinner>
    <p class="ci-spinner">
      LADEN ...
    </p>
  </div>
</div>
